/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {Loader} from './style';

interface ILoaderContainer {
  size?: 'small' | 'medium' | 'large';
  color?: 'light' | 'dark';
}

const LoaderContainer = ({size = 'large', color = 'light'}: ILoaderContainer): JSX.Element => (
  <Loader className={size} color={color}>
    <span className="testId-loader" />
  </Loader>
);

export default LoaderContainer;